exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-circle[data-v-3a8d711c]{border-radius:50%;border:4px solid #f9f9f9;height:100%;width:100%}.selecting:hover h5[data-v-3a8d711c]{color:#c7413c}.selecting:hover div[data-v-3a8d711c]{border:4px solid #c7413c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a8d711c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/rounded.vue
// module id = 349
// module chunks = 0